import * as React from "react";
import { DateFormats, IClinicianStatusChange } from "intake_shared/src/types";
import moment from "../../../../utils/app_moment";
import HistoryIcon from "../../icons/History";
import styles from "./ClinicianStatusHistory.module.scss";

interface ClinicianStatusHistoryProps {
    changes: IClinicianStatusChange[];
}

export default function ClinicianStatusHistory({
    changes,
}: ClinicianStatusHistoryProps) {
    if (changes.length === 0) {
        return null;
    }

    return (
        <section
            className={styles.panel}
            aria-label="Priority and booking pause activity"
        >
            <header className={styles.header}>
                <HistoryIcon />
                <h3 className={styles.title}>Change history</h3>
            </header>
            <ol className={styles.historyList}>
                {changes.map((change) => {
                    const label =
                        change.field === "marked_as_priority"
                            ? change.enabled
                                ? "Added to priority"
                                : "Removed from priority"
                            : change.enabled
                            ? "Bookings paused"
                            : "Bookings resumed";
                    return (
                        <li className={styles.historyItem} key={change.id}>
                            <strong>{label}</strong>
                            <p className={styles.eventMeta}>
                                <time dateTime={change.changed_at.toISOString()}>
                                    {moment(change.changed_at).format(
                                        DateFormats.DAY_YEAR_HOUR_MIN_FORMAT
                                    )}
                                </time>{" "}
                                · {change.changed_by}
                            </p>
                            {change.note && (
                                <p className={styles.note}>{change.note}</p>
                            )}
                        </li>
                    );
                })}
            </ol>
        </section>
    );
}
